import React, {useMemo} from 'react';

import useLoggedInUser from "../hooks/useLoggedInUser.js";

export default function UserNameComponent({ user, selfReference }) {
	const loggedInUser = useLoggedInUser();

	const displayedName = useMemo(() => {
		if(selfReference) {
			if(loggedInUser.id === user.id) {
				return 'You';
			}
		}
		return user.email;
	}, [user]);
	return (
		<span className='user_name_holder'>{displayedName}</span>
	);
}